import ClassicTemplate from "./classic/ClassicTemplate";

// Buyer-side template registry. Keyed by the same ids as the console's
// registry (affiliate-console-frontend/src/pages/CheckoutBuilder/templates/registry.js).
// The two are deliberately separate implementations: this one is optimised for
// conversion and load speed, the console's for authoring.
const TEMPLATES = {
  classic: {
    id: "classic",
    steps: ["form", "plans"],
    Template: ClassicTemplate,
  },
};

export const DEFAULT_TEMPLATE_ID = "classic";

// Never returns undefined. A page carrying an unknown templateId still renders
// and can still take money; a page rendering nothing cannot.
export const resolveTemplate = (templateId) =>
  TEMPLATES[templateId] || TEMPLATES[DEFAULT_TEMPLATE_ID];

export default TEMPLATES;
